import { default as BaseProxyAcquisition } from "@/proxies/base-proxy-acquisition";

/**
 * @class AuthSessionVerificationProxy
 * @description
 * > Class used for initial verification of access token.
 * > Will initiate account linking and account creation if necessary for new SSO login
 * @author Laurence A.
 * @version 1.0
 * @since September 15, 2023 ୧༼ಠ益ಠ༽︻╦╤─ ❤
 */
export default class AuthSessionVerificationProxy extends BaseProxyAcquisition {
  /**
   * @async
   * @function execute
   * @description Method used for
   * @param {Object} input Input parameter
   * @param {String} input.access_token Access token
   * @param {String} input.token_type Token type. e.g. Bearer / Basic
   * @param {String} input.id_token ID token
   * @param {String} input.refresh_token Refresh token
   */
  async execute(input = {}) {
    const backendUrl = await this.getBackendUrl();
    const endpointUrl = `${backendUrl}/auth/session/verify`;
    return this.postData(endpointUrl, {
      it: input.id_token,
      at: input.access_token,
      tt: input.token_type,
      rt: input.refresh_token,
    });
  }
}
